module.exports = __webpack_public_path__ + "img/other_samsung3.1171dfda.jpg";